/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import PdfViewerController from './pdf-viewer-controller';

/**
 * @import ViewerLifeCycleFactory from '../viewer/life-cycle/viewer-life-cycle-factory'
 * @import { IElement } from '../iframe'
 * @import { ViewerControllerFactory } from '../viewer/controller'
 */

/**
 * Továrna pro potřeby ovladače PDF souborů.
 * @implements {ViewerControllerFactory}
 */
export default class PdfViewerControllerFactory {
  /**
   * Vytvoří instanci
   * @param {string} origin Origin, který budou mít zprávy od potomka.
   * @param {number} timeout Maximální doba čekání na navázání komunikace. [ms]
   * @param {ViewerLifeCycleFactory} viewerLifeCycleFactory
   */
  constructor(origin, timeout, viewerLifeCycleFactory) {
    this.origin = origin;
    this.timeout = timeout;
    this.viewerLifeCycleFactory = viewerLifeCycleFactory;
  }

  /** @type {ViewerControllerFactory['create']} */
  create(el, settings) {
    return new PdfViewerController(
      /** @type {IElement} */ (el),
      this.origin,
      this.timeout,
      this.viewerLifeCycleFactory
    );
  }
}
